import promptStyle from "./PromptStyle";

export default (theme) => ({
  prompt: {
    ...promptStyle.prompt,
    color: "white !important",
    backgroundColor: `${theme.secondaryColor} !important`,
    position: "fixed",
    bottom: "65px",
    right: "10px",
    animationName: "$slide-left",
  },
  promptArrow: {
    ...promptStyle.promptArrow,
    composes: "$promptArrow",
    right: "16%",
    borderTopColor: theme.secondaryColor,
  },
  "@keyframes slide-left": {
    "0%": { opacity: "0", transform: "translateX(-40px)" },
    "100%": { opacity: "1", transform: "translateX(0)" },
  },
});
